// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__3CcwB","Tab":"Tabs_Tab__1MZEc","CurrentTab":"Tabs_CurrentTab__2OXBH","TabsUnderLine":"Tabs_TabsUnderLine__tLHrS"};